var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.48438 0.5H10.4844C10.617 0.5 10.7442 0.552678 10.8379 0.646447C10.9317 0.740215 10.9844 0.867392 10.9844 1V9C10.9844 9.13261 10.9317 9.25979 10.8379 9.35355C10.7442 9.44732 10.617 9.5 10.4844 9.5H1.48438C1.35177 9.5 1.22459 9.44732 1.13082 9.35355C1.03705 9.25979 0.984375 9.13261 0.984375 9V1C0.984375 0.867392 1.03705 0.740215 1.13082 0.646447C1.22459 0.552678 1.35177 0.5 1.48438 0.5ZM9.98438 2.619L6.02037 6.169L1.98438 2.608V8.5H9.98438V2.619ZM2.23988 1.5L6.01487 4.831L9.73538 1.5H2.23988Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.ed35c937aee9dcf718c9a179d67aa265.svg";
export { ForwardRef as ReactComponent };